(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  function focusCartShippingEstimator() {
    const estimator = document.getElementById('tcw-shipping-estimator');
    if (!estimator) return;
    estimator.focus({ preventScroll: true });
    estimator.scrollIntoView({ block: 'start', behavior: 'instant' });
  }

  document.addEventListener('click', function (event) {
    const link = event.target.closest('a[href="#tcw-shipping-estimator"]');
    if (!link || !document.getElementById('tcw-shipping-estimator')) return;
    event.preventDefault();
    event.stopPropagation();
    focusCartShippingEstimator();
  }, true);

  if (window.location.hash === '#tcw-shipping-estimator') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', focusCartShippingEstimator, { once: true });
    } else {
      focusCartShippingEstimator();
    }
  }

  } catch(e) { console.error(e); }
})();
})();
